import Vue from 'vue'
import Router from 'vue-router'
import Home from '../pages/Home'
import Register from '../pages/Register'


Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/register',
      name: 'Register',
      component: Register
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js